import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface BranchState {
  // State
  selectedBranchId: number; // -1 represents "All Branches", otherwise a branch ID
  
  // Actions
  selectBranch: (branchId: number) => void;
  clearBranch: () => void;
}

/**
 * Zustand store for branch selection
 * Automatically persists to localStorage using Zustand's persist middleware
 * Note: -1 represents "All Branches"
 */
export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      // Initial state - -1 represents "All Branches"
      selectedBranchId: -1,

      // Actions
      selectBranch: (branchId) =>
        set({ selectedBranchId: branchId }),

      clearBranch: () =>
        set({ selectedBranchId: -1 }), // Reset to "All Branches" instead of null
    }),
    {
      name: 'branch-storage', // localStorage key
      storage: createJSONStorage(() => localStorage),
    }
  )
);

